// Discreet scroll-reveal for the homepage. .sr-init is added by JS only,
// so with JS disabled nothing is ever hidden.
(function () {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
    // Honor reduced-motion for the hero video: pause it so the poster still shows.
    document.querySelectorAll('.hero__video').forEach(function (v) {
      v.removeAttribute('autoplay');
      var pause = function () { try { v.pause(); } catch (e) {} };
      v.addEventListener('loadeddata', pause);
      pause();
    });
    return;
  }
  if (!('IntersectionObserver' in window)) return;

  var main = document.getElementById('MainContent');
  if (!main || main.getAttribute('data-template') !== 'index') return;

  // section-id suffix -> child selector to stagger
  var stagger = {
    section_HTDARK: '.group-block',
    section_testimonials: '.group-block',
    product_list_mQaCY4: '.product-card',
    financing_banner: '.finance-card'
  };

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      var kids = el.querySelectorAll('.sr-init');
      if (kids.length) kids.forEach(function (k) { k.classList.add('sr-in'); });
      else el.classList.add('sr-in');
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -10%', threshold: 0.1 });

  main.querySelectorAll(':scope > .shopify-section').forEach(function (sec, idx) {
    var id = sec.id || '';
    if (id.indexOf('__hero_jVaWmY') !== -1) return;   // main hero
    if (id.indexOf('__trust_bar_lw') !== -1) return;  // above the fold: never hidden
    if (id.indexOf('__marquee_ticker') !== -1) return; // ticker must run from first paint
    if (idx === 0) return;                             // never reveal the first section

    var childSel = null;
    Object.keys(stagger).forEach(function (suffix) {
      if (id.indexOf('__' + suffix) !== -1) childSel = stagger[suffix];
    });

    if (childSel) {
      var kids = sec.querySelectorAll(childSel);
      if (!kids.length) return;
      kids.forEach(function (k, i) {
        k.classList.add('sr-init');
        k.style.setProperty('--sr-delay', (i * 40) + 'ms');
      });
    } else {
      sec.classList.add('sr-init');
    }
    io.observe(sec);
  });
})();
